import styled, { css } from "styled-components";
import Label from "@8x8/oxygen-label";
import { COLORS } from "@/react/theme/constants";

export const PositionedLabel = styled(Label)`
  ${(props) =>
    props.isDisabled &&
    css`
      color: ${COLORS.gray};
    `}
  justify-content: flex-start;
`;
